import { Text } from "@ui-components";
import styled from "styled-components";

export const LinkListItemLinkStyled = styled(Text.Link)`
  &:hover {
    text-decoration: underline;
  }
`;
